<template>
  <div>
    <form class="form-horizontal">
      <fieldset class="academic-panel">
        <legend>{{ $t('preInvoice.academic') }}</legend>
        <div v-if="!studentInfo" class="academic-empty text-center">
          <div class="academic-empty-icon">
            <i class="fa fa-graduation-cap"></i>
          </div>
          <div class="academic-empty-title">
            {{ $t('preInvoice.academicInitialTitle') }}
          </div>
          <div class="academic-empty-hint">
            {{ $t('preInvoice.academicInitialHint') }}
          </div>
        </div>

        <div v-else class="academic-grid">
          <div class="academic-field">
            <label class="required">{{ $t('preInvoice.mainProgram') }}</label>
            <input type="text" class="academic-readonly" readonly :value="studentInfo
              ? studentInfo.academic_class.main_program.acp_name_foreign
              : '-'
              " />
            <div class="validate" v-if="errors.has('acp_id')">
              {{ errors.first('acp_id') }}
            </div>
          </div>

          <div class="academic-field">
            <label class="required">{{ $t('preInvoice.subProgram') }}</label>
            <input type="text" class="academic-readonly" readonly :value="studentInfo
              ? studentInfo.academic_class.sub_program.acps_name_foreign
              : '-'
              " />
            <div class="validate" v-if="errors.has('acps_id')">
              {{ errors.first('acps_id') }}
            </div>
          </div>

          <div class="academic-field">
            <label class="required">Term/Semester</label>
            <a-select v-model="model.ac_term_id" style="width: 100%"
              :disabled="!studentInfo || !termOptions || termOptions.length == 0" :options="termOptions || []"
              @change="onTermChange"></a-select>
            <div class="validate" v-if="errors.has('ac_term_id')">
              {{ errors.first('ac_term_id') }}
            </div>
          </div>

          <div class="academic-field">
            <label class="required">{{ $t('preInvoice.stopDateTerm') }}</label>
            <input type="text" class="academic-readonly" readonly :value="model.term_stop || '-'" />
          </div>

          <div class="academic-field">
            <label class="required">Grade</label>
            <div class="academic-inline-control">
              <a-select v-model="model.grade_id" style="width: 100%"
                :disabled="!studentInfo || !gradeOptions || gradeOptions.length == 0"
                :options="gradeOptions || []"></a-select>
              <button :disabled="!studentInfo || fetching" @click.prevent="fetchAllGrade"
                class="academic-action-button">
                <span v-if="!fetching">{{ $t('preInvoice.allGrade') }}</span>
                <i v-else class="fa fa-spin fa-spinner"></i>
              </button>
            </div>
            <div class="validate" v-if="errors.has('grade_id')">
              {{ errors.first('grade_id') }}
            </div>
          </div>

          <div class="academic-field academic-field-remark">
            <label>{{ $t('preInvoice.remark') }}</label>
            <textarea class="form-control" rows="2" v-model="model.remark" :disabled="!studentInfo"></textarea>
          </div>
        </div>
      </fieldset>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'

export default {
  name: 'preInvoiceAcademic',
  props: ['value', 'studentInfo', 'validate'],
  data() {
    return {
      model: {},
      termOptions: null,
      gradeOptions: [],
      errors: new Errors(),
      fetching: false
    }
  },
  computed: {
    statusText: () => (statusId) => {
      const statusList = {
        1: 'Currrent', 3: 'Next'
      }

      return statusList[statusId] || ''
    },
    gradeLabel: () => (grade) => {
      const statusList = {
        current: 'Current',
        next: 'Next'
      }
      const status = statusList[grade.grade_status]

      return status ? `${grade.grade_name_foreign} - ${status}` : grade.grade_name_foreign
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    ...mapActions('preInvoice', ['preInvoiceFormView']),
    async fetchTerm() {
      if (this.studentInfo) {
        try {
          const response = await this.preInvoiceFormView({
            number_of_term_per_grade: this.studentInfo.academic_class.sub_program.number_of_term_per_grade,
            term_order: this.studentInfo.academic_class.academic_term.term_order,
            end_date_of_term: this.studentInfo.academic_class.academic_term.term_stop,
            grade_id: this.studentInfo.academic_class.grade.grade_id,
            ac_term_id: this.studentInfo.academic_class.academic_term.ac_term_id,
            student_id: this.studentInfo.student_id,
            ac_status_id: this.studentInfo.ac_status_id,
            acps_id: this.studentInfo.academic_class.acps_id,
            next_grade_id: this.studentInfo.academic_class.grade.next_grade_id,
            fnName: 'acTerm'
          });

          this.termOptions = response.acTerm.map(el => ({
            value: el.ac_term_id,
            label: this.statusText(el.ac_status_id) ? `${el.term_name} - ${this.statusText(el.ac_status_id)}` : el.term_name,
            ac_status_id: el.ac_status_id,
            ac_year_id: el.ac_year_id,
            term_stop: el.term_stop
          }));

          this.model.ac_status_id = this.termOptions.length
            ? this.termOptions[this.termOptions.length - 1].ac_status_id
            : '';

          this.model.term_stop = this.termOptions.length
            ? this.termOptions[this.termOptions.length - 1].term_stop
            : '';

          this.model.ac_term_id = this.termOptions.length
            ? this.termOptions[this.termOptions.length - 1].value
            : '';

          this.model.ac_year_id = this.termOptions.length
            ? this.termOptions[this.termOptions.length - 1].ac_year_id
            : '';

          this.selectGradeByAcademicStatus()

        } catch (error) {
          console.error('Error fetching term:', error);
          // Handle error appropriately
        }
      }
    },
    async fetchGrade() {
      if (this.studentInfo) {
        await this.preInvoiceFormView({
          number_of_term_per_grade: this.studentInfo.academic_class.sub_program
            .number_of_term_per_grade,
          term_order: this.studentInfo.academic_class.academic_term.term_order,
          end_date_of_term: this.studentInfo.academic_class.academic_term
            .term_stop,
          grade_id: this.studentInfo.academic_class.grade.grade_id,
          ac_term_id: this.studentInfo.academic_class.academic_term.ac_term_id,
          student_id: this.studentInfo.student_id,
          ac_status_id: this.studentInfo.ac_status_id,
          next_grade_id: this.studentInfo.academic_class.grade.next_grade_id,
          acps_id: this.studentInfo.academic_class.acps_id,
          fnName: 'grade'
        }).then(response => {
          this.gradeOptions = response.grade.map(el => ({
            value: el.grade_id,
            label: this.gradeLabel(el),
            grade_status: el.grade_status
          }))

          this.selectGradeByAcademicStatus()

        })
      }
    },
    async fetchAllGrade() {
      if (this.studentInfo) {
        this.fetching = true
        await this.preInvoiceFormView({
          acps_id: this.studentInfo.academic_class.acps_id,
          fnName: 'getAllGrade'
        }).then(response => {
          this.gradeOptions = response.getAllGrade.map(el => ({
            value: el.grade_id,
            label: el.grade_name_foreign
          }))
          this.model.grade_id = null
        })
          .finally(() => this.fetching = false)
      }
    },
    onTermChange(_, opt) {
      const props = opt.data.props
      this.model.ac_status_id = props.ac_status_id
      this.model.ac_year_id = props.ac_year_id
      this.model.term_stop = props.term_stop || ''
      this.selectGradeByAcademicStatus()
    },
    gradeStatusByAcademicStatus(statusId) {
      const statusList = {
        1: 'current',
        3: 'next'
      }

      return statusList[statusId] || null
    },
    selectGradeByAcademicStatus() {
      const gradeStatus = this.gradeStatusByAcademicStatus(this.model.ac_status_id)
      const grade = this.gradeOptions && this.gradeOptions.find(el => el.grade_status === gradeStatus)

      this.model.grade_id = grade
        ? grade.value
        : this.gradeOptions && this.gradeOptions.length
          ? this.gradeOptions[this.gradeOptions.length - 1].value
          : null
    }
  },
  watch: {
    studentInfo: function () {
      this.model.ac_term_id = null
      this.model.grade_id = null
      this.termOptions = null
      this.gradeOptions = null
      this.fetchTerm()
      this.fetchGrade()
    },
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style lang="css" scoped>
.academic-panel {
  height: 339px;
  overflow: auto;
}

.academic-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 16px;
}

.academic-field {
  min-width: 0;
}

.academic-field label {
  display: block;
  margin-bottom: 5px;
  color: #111827;
  font-weight: 600;
}

.academic-field-remark {
  grid-column: 1 / -1;
}

.academic-inline-control {
  display: flex;
  align-items: center;
  gap: 8px;
}

.academic-empty {
  display: flex;
  min-height: calc(100% - 18px);
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 18px 16px 22px;
  color: #6b7280;
}

.academic-empty-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  margin-bottom: 8px;
  border-radius: 50%;
  background: #f0f7ff;
  color: #1d68b3;
}

.academic-empty-title {
  color: #374151;
  font-weight: 600;
}

.academic-empty-hint {
  max-width: 320px;
  margin: 4px auto 0;
  font-size: 12px;
}

.academic-readonly {
  width: 100%;
  min-height: 32px;
  padding: 6px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background: #f9fafb;
  color: #374151;
}

.academic-action-button {
  flex: 0 0 auto;
  min-width: 84px;
  min-height: 32px;
  padding: 6px 10px;
  border: 1px solid #bfdbfe;
  border-radius: 4px;
  background: #eff6ff;
  color: #1d4ed8;
  white-space: nowrap;
}

.academic-action-button:disabled {
  border-color: #e5e7eb;
  background: #f3f4f6;
  color: #9ca3af;
  cursor: not-allowed;
}

.academic-action-button:focus {
  outline: 2px solid #93c5fd;
  outline-offset: 1px;
}

@media (max-width: 991.98px) {
  .academic-grid {
    grid-template-columns: 1fr;
  }
}
</style>
